/* eslint-disable no-mixed-spaces-and-tabs */
import { SubmissionError } from 'redux-form';
import { REQUIRED_FIELDS } from './constants';
import { goToElement } from '../../utils/goToElement';

export const normalizePhone = value => {
	if (!value) {
		return value;
	}

	if (value === '+') {
		return '';
	}

	const onlyNums = value.replace(/[^\d]/g, '');

	if (onlyNums[0] !== '7' && onlyNums.length === 1) {
		return `+7${onlyNums}`;
	}

	if (onlyNums.length <= 4) {
		return `+7${onlyNums.slice(1, 4)}`;
	}

	if (onlyNums.length <= 7) {
		return `+7(${onlyNums.slice(1, 4)})${onlyNums.slice(4)}`;
	}

	if (onlyNums.length <= 9) {
		return `+7(${onlyNums.slice(1, 4)})${onlyNums.slice(4, 7)}-${onlyNums.slice(7)}`;
	}

	return `+7(${onlyNums.slice(1, 4)})${onlyNums.slice(4, 7)}-${onlyNums.slice(7, 9)}-${onlyNums.slice(9, 11)}`;
};

export const validate = values => {
	REQUIRED_FIELDS.forEach(key => {
		if (!values?.[key]) {
			goToElement(key);
			throw new SubmissionError({ [key]: 'Заполните это поле' });
		}

		if (key === 'email' && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
			goToElement(key);
			throw new SubmissionError({ [key]: 'Не валидный email' });
		}
	});
};

export const transformToValidationErrors = errors => {
	return Object.entries(errors).reduce((result, [key, value]) => {
		return {
			...result,
			[key]: value[0],
		};
	}, {});
};

export const getFormattedRules = (rules, key) => {
	return rules?.[key]
		? {
				access: Boolean(rules?.[key].access),
				create: Boolean(rules?.[key].access) && Boolean(rules?.[key].create),
				update: Boolean(rules?.[key].access) && Boolean(rules?.[key].update),
				delete: Boolean(rules?.[key].access) && Boolean(rules?.[key].delete),
				export: Boolean(rules?.[key].access) && Boolean(rules?.[key].export),
		  }
		: { access: false, create: false, update: false, delete: false, export: false };
};

export const checkEquality = (property, userInfo, formValues) => {
	let value = Boolean(userInfo?.[property]);

	if (
		Boolean(userInfo?.[property]) !== formValues?.[property] &&
		formValues?.[property] !== undefined &&
		formValues?.[property] !== null
	) {
		value = formValues?.[property];
	}

	return value;
};
